import type { TRichMessageTemplate } from 'types/richMessage';

export const RICH_MESSAGE_CUSTOM_MIN_HEIGHT = 520;
export const RICH_MESSAGE_CUSTOM_MAX_HEIGHT = 2080;
export const RICH_MESSAGE_BASE_WIDTH = 1040;
export const RICH_MESSAGE_IMAGE_MAX_BYTES = 10 * 1024 * 1024;

export function findRichMessageTemplate(
  templates: TRichMessageTemplate[] | undefined,
  id: string,
): TRichMessageTemplate | undefined {
  if (!templates?.length || !id) return undefined;
  return templates.find((item) => item.id === id);
}

export function getDefaultRichMessageTemplateId(
  templates: TRichMessageTemplate[] | undefined,
): string {
  const sorted = [...(templates ?? [])].sort(
    (a, b) => a.sortOrder - b.sortOrder,
  );

  return sorted[0]?.id ?? 'SQ_1040_FULL';
}
